module.exports = __webpack_public_path__ + "static/og-80ec3169b74b1ee52140f3492c564420.png";